import { render, staticRenderFns } from "./provinceIdSelect.vue?vue&type=template&id=dfe0beb2&"
import script from "./provinceIdSelect.vue?vue&type=script&lang=js&"
export * from "./provinceIdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports